// boolean as to whether this status code begins with a 4
export default function isErrorStatus(status: number) {
  return status === 403 || status === 404;
}
